import BillingProductEntry from './main';
import {preCheckForMultipleProductEntry, preCheckForProductEntry, syncPreCheckForProductEntry} from './helper/pre';

BillingProductEntry.preCheckForProductEntry = preCheckForProductEntry;
BillingProductEntry.syncPreCheckForProductEntry = syncPreCheckForProductEntry;
BillingProductEntry.preCheckForMultipleProductEntry = preCheckForMultipleProductEntry;

BillingProductEntry.install = function(Vue) {
  Vue.component(BillingProductEntry.name, BillingProductEntry);
};

export default BillingProductEntry;
